<template>
    <li class="nav-item">
        <span class="nav-link" :class="[status !== 'valid' ? 'has-error' : '']">
            <a-icon
                :class="icon.iconClass"
                style="width: 24px; height: 24px"
                :icon="icon.icon"
            />
            <span>{{ text }}</span>
        </span>
    </li>
</template>

<script>
export default {
    props: {
        status: {
            type: String,
            required: true
        },
        text: {
            type: String,
            required: true
        }
    },
    computed: {
        icon() {
            let icon
            let iconClass
            if (this.status === 'valid') {
                icon = 'Success'
                iconClass = 'success'
            } else {
                icon = 'ErrorCircle'
                iconClass = 'error'
            }
            return {
                icon,
                iconClass
            }
        }
    }
}
</script>
